import reducerGenerator from '../comments/reducerGenerator'
import * as ActionTypes from './actionTypes'
import {handleActions} from 'redux-actions'

export default (initAppData) => {
    const commentsReducer = reducerGenerator({
        actionTypes: ActionTypes,
        initAppData: {
            ...initAppData,
            newCommentsTexts: initAppData.COMMENTS.CUSTOMER_NEW_COMMENTS
        }
    })

    const initialState = {
        openCustomerId: null,
        openedFromUrl: false,
        allProjectsAssigned: false,
        canManage: false,
        ...commentsReducer.initialState,
    }

    return handleActions({
        [ActionTypes.OPEN_CUSTOMER_SET]: (state, {payload: openCustomerId}) => ({...state, openCustomerId}),
        [ActionTypes.CUSTOMER_PANEL_OPENED_FROM_URL_SET]: (state, {payload: openedFromUrl}) => ({...state, openedFromUrl}),
        [ActionTypes.ALL_PROJECTS_ASSIGNED_SET]: (state, {payload: allProjectsAssigned}) => ({...state, allProjectsAssigned}),
        [ActionTypes.CAN_MANAGE_SET]: (state, {payload: canManage}) => ({...state, canManage}),
        ...commentsReducer.handlers,
    }, initialState)
}


// WEBPACK FOOTER //
// ./web/js/panels/customer/reducer.js